"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSaveSearchSagas = void 0;
var effects_1 = require("redux-saga/effects");
var UpdateSaveSearchAction_1 = require("@/pages/savesearch/actions/UpdateSaveSearchAction");
var SaveSearchApiSaga_1 = require("@/pages/search/sagas/api/SaveSearchApiSaga");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var SfavSaveSearchSaga_1 = require("@/pages/search/sagas/SfavSaveSearchSaga");
var watchOnCloseClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(UpdateSaveSearchAction_1.default.ON_UPDATE_SAVE_SEARCH_CLOSE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(UpdateSaveSearchAction_1.default.setActive(false))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(100)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(UpdateSaveSearchAction_1.default.setDim(false))];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchSetSearchSetsFromRemote = function () {
    var response, searchSets;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(UpdateSaveSearchAction_1.default.SET_SAVE_SEARCH_SEARCHSETS_FROMREMOTE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(SaveSearchApiSaga_1.getSaveSearchCriteriaApi)];
            case 2:
                response = _a.sent();
                if (!(response.data && response.data.searchSets)) return [3 /*break*/, 4];
                searchSets = response.data.searchSets;
                searchSets.map(function (it) {
                    it.hasMaidRoom = it.hasMaidRoom ? true : false;
                    it.hasOutdoorSpace = it.hasOutdoorSpace ? true : false;
                    it.hasParking = it.hasParking ? true : false;
                    return it;
                });
                return [4 /*yield*/, effects_1.put(UpdateSaveSearchAction_1.default.setSearchSets(response.data.searchSets))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4:
                if (!(response.data.searchSets === null)) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.put(UpdateSaveSearchAction_1.default.setSearchSets([]))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
};
var watchRemoveSearchSet = function () {
    var payload, id, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(UpdateSaveSearchAction_1.default.REMOVE_SAVE_SEARCHSET)];
            case 1:
                payload = (_a.sent()).payload;
                id = payload;
                return [4 /*yield*/, effects_1.call(SaveSearchApiSaga_1.removeSaveSearchApi, id)];
            case 2:
                response = _a.sent();
                if (!(response.data.result.status === 2)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('removeSaveSearchSuccess'))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(UpdateSaveSearchAction_1.default.setSearchSetsFromRemote())];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchOnSearchSetClicked = function () {
    var payload, searchSet, href_1, href;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(UpdateSaveSearchAction_1.default.ON_SEARCH_SET_CLICKED)];
            case 1:
                payload = (_a.sent()).payload;
                searchSet = payload;
                if (!(searchSet.listingTypeId === 4)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.call(SfavSaveSearchSaga_1.getBuildingLinkFromSearchSet, searchSet)];
            case 2:
                href_1 = _a.sent();
                if (!href_1)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.globalSetUrl(href_1))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [4 /*yield*/, effects_1.call(SfavSaveSearchSaga_1.searchSetToUrlAsync, searchSet)];
            case 5:
                href = _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.globalSetUrl(href))];
            case 6:
                _a.sent();
                return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
};
var updateSaveSearchSagas = {
    watchSetSearchSetsFromRemote: watchSetSearchSetsFromRemote,
    watchOnCloseClick: watchOnCloseClick,
    watchRemoveSearchSet: watchRemoveSearchSet,
    watchOnSearchSetClicked: watchOnSearchSetClicked,
};
exports.updateSaveSearchSagas = updateSaveSearchSagas;
